import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container, Row, Col, Card, CardBody, CardTitle, FormGroup, Spinner } from "reactstrap";
import { useParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import { createScorecardClear, getAccountHolderUsers, getChannelData } from 'store/actions';
import {
  Form,
  Input,
  InputGroup,
  Label,
  NavItem,
  NavLink,

  Button,
  TabContent,
  TabPane,
  FormFeedback,
} from "reactstrap"
import Select from "react-select";
import { Country, State } from "country-state-city"


// Form Mask
// import InputMask from "react-input-mask";

//validtions
// Formik validation
import * as Yup from "yup";
import { useFormik, yupToFormErrors } from "formik";
import { Link } from "react-router-dom"
import {
  createScorecard,
  getScorecardsList
} from "store/actions";
import { ANNUAL_REVENUE, INDUSTRY, NUMBER_OF_EMPLOYEES, OWNERSHIP } from './scorecardconfig/scorecardconfig';
import SweetAlert from 'react-bootstrap-sweetalert';


const NewScorecard = () => {
  const [countries, setCountries] = useState(null)
  const [successMsg, setSuccessMsg] = useState(false)

  const [selectedMulti, setselectedMulti] = useState([]);

  const dispatch = useDispatch();
  const { channelData, accountHolderUsers, scorecardData, scorecardsList } = useSelector(state => ({
    channelData: state.GetChannelData.channelData,
    accountHolderUsers: state.AccountHolderUsersReducer.accountHolderUsers,
    scorecardData: state.GetScorecardsListReducer.scorecardData,
    scorecardsList: state.GetScorecardsListReducer.scorecardsList,

  }));
  const [selectedChannelList, setSelectedChannelList] = useState([])
  // function handleMulti(selectedMulti) {
  //   setselectedMulti(selectedMulti);

  // }
  useEffect(() => {
    dispatch(getChannelData());
    dispatch(getAccountHolderUsers(JSON.parse(localStorage.getItem("authUser")).uid))
    if (!scorecardsList[0]) {
      dispatch(getScorecardsList(JSON.parse(localStorage.getItem("authUser")).uid));
    }
    // setChannel(channelData)
  }, [dispatch]);

  ////channellist
  // console.log(selectedMulti)
  // ]);


  const params = useParams()


  //Additional States for handleing custom requests:
  const [isUserAdded, setIsUserAdded] = useState(false)
  // validations
  const validation = useFormik({

    enableReinitialize: true,

    initialValues: {
      scorecardName: '',
      companyName: '',
      contactName: '',
      phone: '',
      email: '',
      companyAddress1: '',
      companyAddress2: '',
      annualRevenue: '',
      country: 'India',
      state: '',
      numberOfEmployee: '',
      industry: '',
      websiteUrl: '',
      ownership: '',
      clientAttribute1: '',
      clientAttribute2: '',
      countryCode: '91' || countries && countries[0].phonecode,
      assignedTo: '',
      selectedChannels: ''
    },

    validationSchema: Yup.object({
      scorecardName: Yup.string().required("Please enter scorecard name"),
      contactName: Yup.string().required("Please enter contact name"),

    }),

    onSubmit: (values) => {
      // setIsUserAdded(true)
      if (selectedMulti && !checkScorecardUniqueName()) {
        setSuccessMsg(true)
        dispatch(createScorecard({
          ...values,
          accountId: JSON.parse(localStorage.getItem("authUser")).uid,
          creatorId: JSON.parse(localStorage.getItem("authUser")).uid,
          lastUpdatedOn: {
            _miliseconds: 0,
            _seconds: new Date().getTime() / 1000
          },
          createdOn: {
            _miliseconds: 0,
            _seconds: new Date().getTime() / 1000
          },
          status: "In progress",
          assignedTo: selectedMulti,
          selectedChannels: selectedChannelList
        }))
      }
      // console.log({
      //   ...values,
      //   // selectAccountUser: selectedMulti,
      //   // selectAccountUser: accountHolderUsers && accountHolderUsers.filter(user => user.id === values.selectAccountUser) || ""
      // })
    },
    onReset: () => {
      // validation.values.scorecardName = ""
      // validation.values.companyName = ""
      // validation.values.contactName = ""
      // validation.values.phone = ""
      // validation.values.email = ""
      // validation.values.companyAddress1 = ""
      // validation.values.companyAddress2 = ""
      // validation.values.annualRevenue = ""
      // validation.values.country = 'India',
      // validation.values.state = ""
      // validation.values.numberOfEmployee = ""
      // validation.values.industry = ""
      // validation.values.websiteUrl = ""
      // validation.values.ownership = ""
      // validation.values.clientAttribute1 = ""
      // validation.values.clientAttribute2 = ""
      // validation.values.countryCode = '91'
      // validation.values.assignedTo = ""
      // validation.values.selectedChannels = ''
      setselectedMulti([])
      var allCheckbox = document.querySelectorAll(".test")
      allCheckbox.forEach(checkbox => {
        checkbox.checked = false
      })
      setSelectedChannelList([])
    }

  });

  const getSelectedUsersList = () => {
    const optionGroup = accountHolderUsers.map(user => {
      return {
        label: user.contactName,
        value: user.id,
        accountUserContactName: user.contactName,
        accountUserId: user.id
      }
    })

    return [
      {
        options: [
          ...optionGroup
        ]
      }
    ]


  }
  useEffect(() => {
    setCountries(Country.getAllCountries())
  }, [])

  const GetCountryByCode = () => {
    if (countries) {

      var country = countries.filter(country => country.name === validation.values.country)
      return State.getStatesOfCountry(country[0].isoCode)
    }
  }

  const checkScorecardUniqueName = () => {
    var isNameAvailable = scorecardsList.map(scorecard => scorecard.scorecardName)
    var isIndexAvailable = isNameAvailable.indexOf(validation.values.scorecardName)
    if (isIndexAvailable >= 0 || validation.values.scorecardName === "") {
      return true
    } else {
      return false
    }
    // return IsNameAvailable.indexOf(validation.values.scorecardName)
  }
  return (
    <>
      <div className="page-content">
        <MetaTags>
          <title> Mambo - Create New Scorecard</title>
        </MetaTags>

        <Container fluid={true}>
          {
            scorecardData.status === 200 &&
            <SweetAlert
              // title="Scorecard created successfully!"
              success
              confirmBtnBsStyle="primary"

              onConfirm={() => {
                setSuccessMsg(false)
                dispatch(createScorecardClear())
                validation.handleReset()
              }}
            >Scorecard created successfully
            </SweetAlert>

          }
          {
            scorecardData.status === 403 &&

            <SweetAlert
              // title="Failed to create scorecard!"
              error
              confirmBtnBsStyle="primary"

              onConfirm={() => {
                setSuccessMsg(false)
                dispatch(createScorecardClear())
              }}
            >Failed to create scorecard
            </SweetAlert>
          }

          <Row>
            <Col xl="12" style={{ margin: "auto" }}>
              <Card>
                <CardBody>



                  <Form className="needs-validation outer-repeater" autoComplete='off'
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit()
                      return false;
                    }}>
                    {/* <Row>
                   
                
                    <h4 className="card-title" style={{textTransform: ""}}>Create New Scorecard </h4>
                
                    
                </Row><br></br> */}
                    <Row>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <label>Scorecard File Name</label>
                          <Input
                            name="scorecardName"
                            placeholder='scorecard file name'
                            type="text"
                            className="form-control"
                            id="txtscorecardName"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.scorecardName || ""}
                            invalid={
                              validation.touched.scorecardName && checkScorecardUniqueName() ? true : false
                            }
                          />
                          {validation.touched.scorecardName && checkScorecardUniqueName() ? (
                            <FormFeedback type="invalid">{
                              checkScorecardUniqueName() && validation.values.scorecardName !== "" ?
                                "Scorecard name must be unique" : validation.errors.scorecardName}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <div className="mb-3">

                          <label className="control-label">
                            Assign Scorecard To
                          </label>
                          <Select
                            value={selectedMulti}
                            isMulti={true}
                            onChange={(e) => {
                              // handleMulti(e);
                              setselectedMulti(e)
                            }}
                            onBlur={validation.handleBlur}

                            options={getSelectedUsersList()}
                            classNamePrefix="select2-selection"
                          />


                        </div>

                      </Col>
                    </Row><br></br>
                    <Row>


                      <h4 className="card-title" style={{ color: "Background" }}  >Client Information</h4>


                    </Row><br></br>

                    <Row>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Company Name</label>
                          <Input
                            name="companyName"
                            placeholder="company name"
                            type="text"
                            className="form-control"
                            id="txtcompanyName"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.companyName || ""}
                            invalid={
                              validation.touched.companyName && validation.errors.companyName ? true : false
                            }
                          />
                          {validation.touched.companyName && validation.errors.companyName ? (
                            <FormFeedback type="invalid">{validation.errors.companyName}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Contact Name</label>
                          <Input
                            name="contactName"
                            placeholder="contact name"
                            type="text"
                            className="form-control"
                            id="txtcontactName"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.contactName || ""}
                            invalid={
                              validation.touched.contactName && validation.errors.contactName ? true : false
                            }
                          />
                          {validation.touched.contactName && validation.errors.contactName ? (
                            <FormFeedback type="invalid">{validation.errors.contactName}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="2" >
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom01">Phone</Label>
                          <select
                            className="form-control"
                            name="countryCode"
                            disabled={isUserAdded}
                            value={validation.values.countryCode}
                            onChange={validation.handleChange}
                          >

                            {
                              countries && countries.map(country => (
                                <option key={country.name} value={country.phonecode} >{country.flag}
                                  &nbsp;&nbsp;{country.isoCode}
                                  &nbsp;&nbsp;({country.phonecode})</option>
                              ))
                            }

                          </select>

                          {validation.touched.countryCode && validation.errors.countryCode ? (
                            <FormFeedback type="invalid">{validation.errors.countryCode}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>


                      <Col md="2">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom01">&nbsp;</Label>
                          <Input
                            name="phone"
                            placeholder="phone"
                            type="number"
                            min="1"
                            style={{
                              MozAppearance: "none",
                            }}
                            className="form-control"
                            // disabled={isUserAdded}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.phone || ""}
                            invalid={
                              validation.touched.phone && validation.errors.phone ? true : false
                            }
                          />
                          {validation.touched.phone && validation.errors.phone ? (
                            <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Email</label>
                          <Input
                            name="email"
                            placeholder="email"
                            type="text"
                            className="form-control" channel
                            id="txtemail"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email && validation.errors.email ? true : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Company Address</label>
                          <Input
                            name="companyAddress1"
                            placeholder="line 1"
                            type="text"
                            className="form-control"
                            id="txtcompanyAddress1"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.companyAddress1 || ""}
                            invalid={
                              validation.touched.companyAddress1 && validation.errors.companyAddress1 ? true : false
                            }
                          />
                          {validation.touched.companyAddress1 && validation.errors.companyAddress1 ? (
                            <FormFeedback type="invalid">{validation.errors.companyAddress1}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* <Col md="4">
                        <FormGroup className="mb-3">
                          <label> Company Address </label>
                          <Input
                            name="companyAddress2"
                            placeholder="line 2"
                            type="text"
                            className="form-control"
                            id="txtcompanyAddress2"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.companyAddress2 || ""}
                            invalid={
                              validation.touched.companyAddress2 && validation.errors.companyAddress2 ? true : false
                            }
                          />
                          {validation.touched.companyAddress2 && validation.errors.companyAddress2 ? (
                            <FormFeedback type="invalid">{validation.errors.companyAddress2}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Email</label>
                          <Input
                            name="email"
                            placeholder="email"
                            type="text"
                            className="form-control" channel
                            id="txtemail"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email && validation.errors.email ? true : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col> */}
                      <Col md="2">
                        <FormGroup className="mb-3">
                          <label>Country</label>
                          <Input type="select"
                            className="form-select"
                            name="country"
                            onChange={validation.handleChange}
                            invalid={
                              validation.touched.country && validation.errors.country ? true : false
                            } value={validation.values.country || ""}>

                            <option value="">choose</option>
                            {
                              countries && countries.map(country => (
                                <option key={country.name} value={country.name} >{country.flag}&nbsp;&nbsp;{country.name}</option>

                              ))
                            }
                          </Input>
                          {validation.touched.country && validation.errors.country ? (
                            <FormFeedback type="invalid">{validation.errors.country}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="2">
                        <FormGroup className="mb-3">
                          <label>State</label>
                          <Input type="select"
                            className="form-select"
                            name="state"
                            onChange={validation.handleChange}
                            invalid={
                              validation.touched.state && validation.errors.state ? true : false
                            } value={validation.values.state || ""}>

                            <option value="">choose</option>
                            {
                              countries && GetCountryByCode().map(state => (
                                <option key={state.name} value={state.name} >{state.name}</option>

                              ))
                            }
                          </Input>
                          {validation.touched.state && validation.errors.state ? (
                            <FormFeedback type="invalid">{validation.errors.state}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                    </Row>

                    <Row>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Annual Revenue</label>
                          <Input type="select"
                            className="form-select"

                            name="annualRevenue"
                            onChange={validation.handleChange}
                            invalid={
                              validation.touched.annualRevenue && validation.errors.annualRevenue ? true : false
                            } value={validation.values.annualRevenue || ""}>

                            <option value="">choose</option>
                            {
                              ANNUAL_REVENUE.data.map((revenue, i) => <option key={i} >{revenue}</option>)
                            }
                          </Input>
                          {validation.touched.annualRevenue && validation.errors.annualRevenue ? (
                            <FormFeedback type="invalid">{validation.errors.annualRevenue}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      {/* <Col md="4">
                        <FormGroup className="mb-3">
                          <label>State/country</label>
                          <Input type="select"
                            className="form-select"
                            name="country"
                            onChange={validation.handleChange}
                            invalid={
                              validation.touched.country && validation.errors.country ? true : false
                            } value={validation.values.country || ""}>

                            <option value="">choose</option>
                            {
                              countries && GetCountryByCode().map(country => (
                                <option key={country.name} value={country.name} >{country.name}</option>

                              ))
                            }
                          </Input>
                          {validation.touched.country && validation.errors.country ? (
                            <FormFeedback type="invalid">{validation.errors.country}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col> */}
                      <Col md="4">  <FormGroup className="mb-3">
                        <label>Number Of Employees</label>
                        <Input type="select"
                          className="form-select"
                          name="numberOfEmployee"
                          onChange={validation.handleChange}
                          invalid={
                            validation.touched.numberOfEmployee && validation.errors.numberOfEmployee ? true : false
                          } value={validation.values.numberOfEmployee || ""}>
                          <option value="">choose</option>
                          {
                            NUMBER_OF_EMPLOYEES.data.map((Employee, i) => <option key={i} >{Employee}</option>)
                          }
                        </Input>
                        {validation.touched.numberOfEmployee && validation.errors.numberOfEmployee ? (
                          <FormFeedback type="invalid">{validation.errors.numberOfEmployee}</FormFeedback>
                        ) : null}
                      </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Industry</label>
                          <Input type="select"
                            className="form-select"
                            name="industry"
                            onChange={validation.handleChange}
                            invalid={
                              validation.touched.industry && validation.errors.industry ? true : false
                            } value={validation.values.industry || ""}>

                            <option value="">choose</option>
                            {
                              INDUSTRY.data.map((industry, i) => <option key={i} >{industry}</option>)
                            }
                          </Input>
                          {validation.touched.industry && validation.errors.industry ? (
                            <FormFeedback type="invalid">{validation.errors.industry}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>

                      {/* <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Industry</label>
                          <Input type="select"
                            className="form-select"
                            name="industry"
                            onChange={validation.handleChange}
                            invalid={
                              validation.touched.industry && validation.errors.industry ? true : false
                            } value={validation.values.industry || ""}>

                            <option value="">choose</option>
                            {
                              INDUSTRY.data.map((industry, i) => <option key={i} >{industry}</option>)
                            }
                          </Input>
                          {validation.touched.industry && validation.errors.industry ? (
                            <FormFeedback type="invalid">{validation.errors.industry}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col> */}
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Website URL</label>
                          <Input
                            name="websiteUrl"
                            placeholder="website url"
                            type="text"
                            className="form-control"
                            id="txtwebsiteUrl"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.websiteUrl || ""}
                            invalid={
                              validation.touched.websiteUrl && validation.errors.websiteUrl ? true : false
                            }
                          />
                          {validation.touched.websiteUrl && validation.errors.websiteUrl ? (
                            <FormFeedback type="invalid">{validation.errors.websiteUrl}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label>Ownership</label>
                          <Input type="select"
                            className="form-select"
                            name="ownership"
                            onChange={validation.handleChange}
                            invalid={
                              validation.touched.ownership && validation.errors.ownership ? true : false
                            } value={validation.values.ownership || ""}>

                            <option value="">choose</option>
                            {
                              OWNERSHIP.data.map((owner, i) => <option key={i} >{owner}</option>)
                            }
                          </Input>
                          {validation.touched.ownership && validation.errors.ownership ? (
                            <FormFeedback type="invalid">{validation.errors.ownership}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>


                      {/* </Row> */}

                      {/* <Row> */}
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <label> Client Attribute 1</label>
                          <Input
                            name="clientAttribute1"
                            placeholder="client attribute 1"
                            type="text"
                            className="form-control"
                            id="txtclientAttribute1"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.clientAttribute1 || ""}
                            invalid={
                              validation.touched.clientAttribute1 && validation.errors.clientAttribute1 ? true : false
                            }
                          />
                          {validation.touched.clientAttribute1 && validation.errors.clientAttribute1 ? (
                            <FormFeedback type="invalid">{validation.errors.clientAttribute1}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      {/* <Col md="4">
                        <FormGroup className="mb-3">
                          <label> Client Attribute 2</label>
                          <Input
                            name="clientAttribute2"
                            placeholder="client attribute 2"
                            type="text"
                            className="form-control"
                            id="txtclientAttribute2"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.clientAttribute2 || ""}
                            invalid={
                              validation.touched.clientAttribute2 && validation.errors.clientAttribute2 ? true : false
                            }
                          />
                          {validation.touched.clientAttribute2 && validation.errors.clientAttribute2 ? (
                            <FormFeedback type="invalid">{validation.errors.clientAttribute2}</FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col> */}
                    </Row><br></br>
                    <Row>

                      <div className="title"><label>Choose Channels</label></div>
                      {
                        !channelData[0] && <Spinner />
                      }
                      {channelData && channelData.map((channel, index) =>
                      (

                        <div className='col-lg-3' key={index}><br></br>
                          <input value={channel.channelId} type="checkbox" style={{ marginRight: "10px" }}
                          className = "test"
                            onChange={(e) => {
                              // var channels = channelData.filter(channel => channel.channelId === e.target.value)
                              // console.log(e.target.checked)
                              if (e.target.checked) {
                                var channels = channelData.filter(channel => channel.channelId === e.target.value)
                                setSelectedChannelList((p) => [...p, ...channels])
                              } else {
                                // var channels = channelData.filter(channel => channel.channelId === e.target.value)
                                setSelectedChannelList(selectedChannelList.filter(channelList => channelList.channelId !== e.target.value))

                              }

                            }}
                          />
                          {channel.channelName}

                        </div>
                      )
                      )

                    }

                    </Row><br></br>

                    <Row>
                      <Col md="8"></Col>
                      <Col md="2">
                        <FormGroup className="mb-3">
                          <Button color="danger"
                            type='reset'
                            onClick={() => {
                              // ResetForm()
                              validation.handleReset()
                            }}
                            block >
                            Reset
                          </Button>
                        </FormGroup>
                      </Col>
                      <Col md="2">
                        <FormGroup className="mb-3">
                          {/* <Button color="primary" type="submit"
                            disabled={selectedMulti[0] === undefined ? true : false}

                            block >

                            Create

                          </Button> */}
                          <Button
                            color="primary"
                            type="submit"
                            disabled={selectedMulti[0] === undefined || successMsg? true : false}
                            block
                          >
                            {successMsg ? "" : "Create"}
                            {successMsg ? (
                              <Spinner type="border" size="sm" />
                            ) : null}



                          </Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );




}

export default NewScorecard;